import React, { Component } from "react";
import ReactDOM from "react-dom";
import { HotKeys } from "react-hotkeys";

/**
 * @description 修饰器  用于修饰pagination  使其获得快捷键的能力
 * @param  {...any} params
 */
function hotkeys(...params) {
    let hotKeyboard = !!params[0];

    let { prevPage, nextPage, ...others } = params[1] || {};

    return function (WrappedComponent) {
        const defaultProps = {
            current: 1,
            pageSizeOptions: ["5", "10", "15", "20"],
            pageSize: 5,
        };
        class WrappedPagination extends Component {
            constructor(props) {
                super(props);
                this.state = { current: props.activePage || props.current };
                // 缓存每页页数
                this.pageSize = props.pageSize;
            }

            componentWillReceiveProps(nextProps) {
                if (
                    !!nextProps.current &&
                    nextProps.current !== this.state.current
                ) {
                    this.setState({ current: nextProps.current });
                }
                if (
                    nextProps.pageSize &&
                    this.props.pageSize !== nextProps.pageSize
                ) {
                    this.pageSize = nextProps.pageSize;
                }
                if (
                    !!nextProps.activePage &&
                    nextProps.activePage !== this.state.current
                ) {
                    this.setState({ current: nextProps.activePage });
                }
                if (
                    nextProps.dataNum &&
                    this.props.dataNum !== nextProps.pageSize
                ) {
                    this.pageSize = nextProps.dataNum;
                }
            }

            handleSelect(eventKey) {
                this.setState({ current: eventKey });
                this.props.onChange && this.props.onChange(eventKey);
                this.props.onSelect && this.props.onSelect(eventKey);
            }

            onPageSizeChange = (index, value) => {
                const { onPageSizeChange, onDataNumSelect } = this.props;
                this.pageSize = value;
                if (typeof onPageSizeChange === "function") {
                    onPageSizeChange(index, value);
                }
                if (typeof onDataNumSelect === "function") {
                    onDataNumSelect(index, value);
                }
            };

            render() {
                let {
                    onChange = () => { },
                    onSelect = () => { },
                    current,
                    activePage,
                    total,
                    pageSize,
                    hotkeyAttach,
                    ncHotKeyboard = hotKeyboard,
                } = this.props;
                current = activePage || current;
                return ncHotKeyboard ? (
                    <HotKeys
                        keyMap={{
                            rightHandler: [nextPage || "ctrl+right"],
                            leftHandler: [prevPage || "ctrl+left"],
                        }}
                        handlers={{
                            rightHandler: () => {
                                let attachElement =
                                    (typeof hotkeyAttach === "string"
                                        ? document.querySelector(hotkeyAttach)
                                        : hotkeyAttach) ||
                                    ReactDOM.findDOMNode(this.wrapped);
                                // 如果当前focus元素在
                                if (
                                    attachElement === document.activeElement ||
                                    attachElement.contains(
                                        document.activeElement,
                                    )
                                ) {
                                    // console.log("nextPage trigger");
                                    pageSize = pageSize || this.pageSize;
                                    if (current * pageSize < total) {
                                        this.setState({ current: current + 1 });
                                        onChange(current + 1);
                                        onSelect(current + 1);
                                    }
                                }
                            },
                            leftHandler: () => {
                                let attachElement =
                                    (typeof hotkeyAttach === "string"
                                        ? document.querySelector(hotkeyAttach)
                                        : hotkeyAttach) ||
                                    ReactDOM.findDOMNode(this.wrapped);
                                // 如果当前focus元素在
                                if (
                                    attachElement === document.activeElement ||
                                    attachElement.contains(
                                        document.activeElement,
                                    )
                                ) {
                                    // console.log("prevPage trigger");
                                    if (current > 1) {
                                        this.setState({ current: current - 1 });
                                        onChange(current - 1);
                                        onSelect(current + 1);
                                    }
                                }
                            },
                        }}
                        ref={dom => (this.wrapped = dom)}
                        className="pagination-hotkeys-wrapper"
                        focused={true}
                        attach={document.body}
                        {...others}
                    >
                        <WrappedComponent
                            // ref={obj => (this.wrappedComponent = obj)}
                            {...this.props}
                            onChange={this.handleSelect.bind(this)}
                            onPageSizeChange={this.onPageSizeChange}
                            current={this.state.current}
                        />
                    </HotKeys>
                ) : (
                    <WrappedComponent
                        // ref={obj => (this.wrappedComponent = obj)}
                        {...this.props}
                        onChange={this.handleSelect.bind(this)}
                        onPageSizeChange={this.onPageSizeChange}
                        current={this.state.current}
                    />
                );
            }
        }
        WrappedPagination.defaultProps = defaultProps;
        return WrappedPagination;
    };
}

export default hotkeys;
